import React, { useContext, useMemo } from 'react'

import { DataContext } from '../DataContext'

export default () => {
    const { submit, isSubmitting, facilityID, formType } = useContext(DataContext)

    const buttonDisabled = useMemo(() => {
        if (formType && formType.Link === 'merge') {
            return false
        }
        
        return facilityID == null || isNaN(facilityID)
    }, [facilityID, formType])

    return (
        <div className="submitButtonWrapper">
            <button
                className={`button is-link ${isSubmitting ? 'is-loading' : ''}`}
                type="button"
                onClick={() => submit()}
                disabled={!!buttonDisabled}
            >
                {`Submit`}
            </button>
        </div>
    )
}
